<template>
  <el-main>
    <query-gather :is-add="authorityMap.isAdd" :is-input="true" :is-query="true" :is-reset="true"
                  :cur-input-tip="curInputTip"
                  style="margin-top: -2vh"
                  @qgAddDeal="addItemDeal" @qgQueryDeal="qgQuery"
                  @qgResetDeal="resetReshycnDataDeal"></query-gather>
    <div class="commonDiv">
      <el-table
          :data="reshycnTableData"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          border
          ref="reshycnTableRef"
          size="mini"
          @selection-change="tableSelectionChange"
          @sort-change="reshycnSortChange"
          :row-style="tableRowClassName"
          max-height="calc(100% - 60px)"
          style="width: 100%;"
          height="calc(100% - 60px)"
          :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.6rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'6.5vh'}">
        <template v-for="(item,index) in reshycnTitles">
          <template v-if="index ===0">
            <el-table-column
                :prop="item.prop"
                :width="item.width"
                :label="item.label"
                :align="item.align"
                :sortable="item.sortable"
                show-overflow-tooltip>
              <template slot-scope="scope">
                <a style="color: #46adf5; cursor: pointer;"
                   @click="reshycnClickDeal(scope.row)">{{ scope.row.hycncd }}</a>
              </template>
              <template v-for="(child,index) in item.children" v-show="item.children">
                <el-table-column
                    :prop="child.prop"
                    :width="child.width"
                    :label="child.label"
                    :align="child.align"
                    :sortable="child.sortable"
                    show-overflow-tooltip
                ></el-table-column>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column
                :prop="item.prop"
                :width="item.width"
                :label="item.label"
                :align="item.align"
                :sortable="item.sortable"
                show-overflow-tooltip
            >
              <template v-for="(child,index) in item.children" v-show="item.children">
                <el-table-column
                    :prop="child.prop"
                    :width="child.width"
                    :label="child.label"
                    :align="child.align"
                    :sortable="child.sortable"
                    show-overflow-tooltip
                ></el-table-column>
              </template>
            </el-table-column>
          </template>
        </template>
        <el-table-column label="操作" align="center" width="100" v-if="authorityMap.isDel">
          <template slot-scope="scope">
            <el-tooltip content="删除" effect="light" v-if="authorityMap.isDel">
              <el-popconfirm
                  title="确定删除吗？"
                  @confirm="reshycnItemDeleteDeal(scope.row)"
              >
                <img
                    src="~@/assets/images/operates/delete.png"
                    alt=""
                    slot="reference"
                    style="cursor: pointer;width: 3.5vh;height: 3.5vh;"
                />
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>
      <div class="commonPage2">
        <el-pagination
            @size-change="reshycnHandleSizeChange"
            @current-change="gzHandleCurrentChange"
            :page-sizes="[10, 20, 30]"
            :page-size="params.size"
            :current-page="params.current"
            layout="total, prev, pager, next,sizes, jumper"
            background
            :total="params.total"
        >
        </el-pagination>
      </div>
    </div>
    <data-dialog :dialog-title="reshycnDialog.title" :is-visible="reshycnDialog.reshycnFormVisible" :is-read="isRead"
                 :is-own-style="true"
                 :dg-style="dgStyle"
                 @dgVerifyDeal="dgVerifyDeal('reshycnDialog','dialog')" ref="reshycnDialog"
                 @dgConfirmDeal="dgReshycnConfirmDeal"
                 @dgCancelDeal="dgCancelDeal">
      <div slot="dialogFrom">
        <el-form ref="dialog" :model="reshycnDialog.data" :rules="reshycnRules" label-width="100px" label-position="top"
                 :disabled="isRead"
                 class="commonForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="编号" prop="hycncd" style="width: 70%;">
                <el-input v-model="reshycnDialog.data['hycncd']" clearable :disabled="!this.isAddData"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="名称" prop="hycnnm" style="width: 70%;">
                <el-input v-model="reshycnDialog.data['hycnnm']" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属建筑物" prop="fhycncd" style="width: 70%;">
                <el-select
                    v-model="reshycnDialog.data['fhycncd']"
                    size="large"
                    placeholder="请选择所属建筑物"
                    style="width: 100%;"
                >
                  <el-option
                      v-for="item in jzwMcOptions"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="序号" prop="no" style="width: 70%;">
                <el-input v-model="reshycnDialog.data['no']" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </data-dialog>
  </el-main>
</template>

<script>
import BottomPagination from "../../components/tableGather/bottomPagination";
import DataDialog from "../../components/tableGather/dataDialog";
import QueryGather from "../../components/buttonGather/queryGather";

/**
 * @Author: ygh
 * @Date: 2024/5/22 15:31
 * @Description:建筑物数据管理页面
 */
export default {
  name: "reshycn",
  mounted() {
    this.initReshycnData();
  },
  components: {BottomPagination, DataDialog, QueryGather},
  data() {
    let validateBhNum = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback();
      } else {
        if (value.length <= 20) {
          let reg = /^[a-zA-Z0-9_\-+#@]*$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error("只能包含a-z、A-Z、0-9及_-+#@特殊字符"));
          }
        } else {
          return callback(new Error("长度不能超过20个字符"));
        }
      }
    };
    let validateXhNum = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback();
      } else {
        const reg = /^[0-9][0-9]*$/;
        if (reg.test(value)) {
          value = value + '';
          if (value.length > 9) {
            return callback(new Error("序号长度不超过9个字符"));
          }
          callback();
        } else {
          return callback(new Error("序号只能填0-9的数字"));
        }
      }
    };
    let validateMcLen = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback();
      } else {
        if (value.length > 30) {
          return callback(new Error("长度不能超过30个字符"));
        } else {
          return callback();
        }
      }
    };
    return {
      authorityMap: {
        isAdd: false,//新增权限
        isUpdate: false,//修改权限
        isDel: false,//删除权限
        isView: false,//查看权限
      },
      isRead: false,
      isAddData:false,
      stRemHeight: 0,
      curInputTip: '请输入编号或者名称',
      staffDataArr: [],
      reshycnTitles: [
        {
          prop: 'hycncd', label: '编号', width: null, align: 'center', sortable: false,
        },
        {
          prop: 'hycnnm', label: '名称', width: null, align: 'center', sortable: false,
        }, {
          prop: 'fhycnnm', label: '所属建筑物', width: null, align: 'center', sortable: false,
        }, {
          prop: 'no', label: '序号', width: null, align: 'center', sortable: true,
        },
      ],
      reshycnTableData: [],
      reshycnRules: {
        hycnnm: [
          {required: true, message: "请输入名称", trigger: "blur"},
          {validator: validateMcLen, trigger: 'blur'},
        ],
        fhycncd: [
          {required: true, message: "请选择所属建筑物", trigger: "blur"},
        ],
        no: [
          {required: true, message: "请输入序号", trigger: "blur"},
          {validator: validateXhNum, trigger: 'blur'},
        ],
        hycncd: [
          {required: true, message: "请输入编号", trigger: "blur"},
          {validator: validateBhNum, trigger: 'blur'},
        ],
      },
      params: {
        total: 1,
        size: 10,
        current: 1,
      },
      loading: false,
      reshycnMultiple: true,
      reshycnMultipleSelection: [],
      curInputValue: '',
      jzwMcOptions: [],//建筑物options
      dgStyle: {
        height: '45%',
        marginTop: '0',
      },
      reshycnDialog: {
        title: "",
        reshycnFormVisible: false,
        data: {
          "hycnnm": "",
          "fhycncd": "",
          "no": "",
          "hycncd": "",
        },
      },
      dialogData: {
        "hycnnm": "",
        "fhycncd": "",
        "no": "",
        "hycncd": "",
      },
    }
  },
  created() {
    let windowHeight =
        document.documentElement.clientHeight || document.bodyclientHeight;
    this.stRemHeight = windowHeight / 100;
  },
  methods: {
    initReshycnData() {
      this.pageAuthorityDeal();
      this.getJzwOptions();
      this.getReshycnData();
    },
    pageAuthorityDeal() {
      const thirdAuthority = JSON.parse(localStorage.getItem("thirdAuthority"))
      const qx = thirdAuthority[this.$route.name];
      if (qx === 'all' || qx === null) {
        this.authorityMap.isAdd = true;
        this.authorityMap.isDel = true;
        this.authorityMap.isUpdate = true;
        this.authorityMap.isView = true;
      } else {
        this.authorityMap.isAdd = qx.indexOf('新增') !== -1;
        this.authorityMap.isDel = qx.indexOf('删除') !== -1;
        this.authorityMap.isUpdate = qx.indexOf('修改') !== -1;
        this.authorityMap.isView = qx.indexOf('查询') !== -1;
      }
      // console.log("当前页面三级菜单权限", thirdAuthority, this.authorityMap);
    },
    getJzwOptions() {
      this.request.get('/rm-bhycn/queryHycnList').then(res => {
        if (res.ok) {
          if (res.data != null) {
            // console.log(res, '===getJzwOptions===');
            this.jzwMcOptions = [];
            for (let i = 0; i < res.data.length; i++) {
              this.jzwMcOptions.push({
                value: res.data[i]['k'],
                text: res.data[i]['v'],
              });
            }
          } else {
            this.$message.info("获取建筑物选择数据为空");
          }
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    dgCancelDeal() {
      if (this.reshycnDialog.reshycnFormVisible) {
        this.reshycnDialog.reshycnFormVisible = false;
        this.$refs['dialog'].clearValidate();
      }
    },
    dgReshycnConfirmDeal() {
      this.isRead = false;
      if (this.isAddData) {
        this.addReshycn();
      } else {
        this.updateReshycn();
      }
    },
    dgVerifyDeal(dgRef, frRef) {
      this.$refs[frRef].validate((valid) => {
        if (valid) {
          this.$refs[dgRef].isShowPop(true);
        } else {
          this.$refs[dgRef].isShowPop(false);
        }
      });
    },
    addReshycn() {
      this.request.post('/rm-breshycn/addResHycn', this.reshycnDialog.data).then(res => {
        if (res.ok) {
          this.reshycnDialog.reshycnFormVisible = false;
          this.reshycnDialog.data = {};
          this.isAddData = false;
          this.$message.success('成功添加建筑物信息');
          this.getReshycnData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    updateReshycn() {
      // console.log("======updateReshycn======", this.reshycnDialog.data);
      this.request.post('/rm-breshycn/modifyResHycn', this.reshycnDialog.data).then(res => {
        if (res.ok) {
          this.reshycnDialog.reshycnFormVisible = false;
          this.reshycnDialog.data = {};
          this.isAddData = false;
          this.$message.success('成功修改建筑物信息');
          this.getReshycnData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    resetReshycnDataDeal() {
      this.curInputValue = '';
      this.clearTableStatus();
      this.getReshycnData();
    },
    clearTableStatus() {
      this.$refs.reshycnTableRef.clearSort();
    },
    initgetReshycnData() {
      this.params = {
        total: 0,
        size: 10,
        current: 1,
      };
      this.getReshycnData();
    },
    qgQuery(params) {
      this.curInputValue = params.curInputValue;
      this.clearTableStatus();
      this.getReshycnData();
    },
    addItemDeal() {
      this.reshycnDialog.title = '新增建筑物信息';
      this.reshycnDialog.reshycnFormVisible = true;
      this.reshycnDialog.data = {...this.dialogData};
      this.isAddData = true;
      this.isRead = false;
      // console.log("======addItemDeal======", this.reshycnDialog, this.btnIndex);
    },
    reshycnItemDeleteDeal(row) {
      this.request.delete('/rm-breshycn/v1/' + row['id']).then(res => {
        if (res.ok) {
          this.$message.success("数据删除成功");
          this.initgetReshycnData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    reshycnSortChange(column) {
      let params = {
        total: 0,
        size: 10,
        current: 1,
        order: column.order === "descending" ? 1 : 0,
      };
      this.params = {};
      this.params = params;
      this.getReshycnData();
    },
    tableSelectionChange(val) {
      this.reshycnMultiple = !val.length;
      this.reshycnMultipleSelection = val;
    },
    reshycnClickDeal(row) {
      if (this.authorityMap.isView || this.authorityMap.isUpdate) {
        this.isAddData = false;
        this.setReshycnDataToDialog(row);
      }
    },
    setReshycnDataToDialog(row) {
      this.reshycnDialog.title = '修改建筑物信息'
      this.reshycnDialog.reshycnFormVisible = true;
      this.isRead = this.authorityMap.isView && !this.authorityMap.isUpdate;
      this.reshycnDialog.data = {};
      this.reshycnDialog.data = {...row};
      // console.log("======reshycn======", this.reshycnDialog.data);
    },
    tableRowClassName({row, rowIndex}) {
      return {
        backgroundColor: '#ffffff',
        fontSize: '1.4rem',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontFamily: 'PingFang SC',
        color: '#616f7b',
        height: '6.55vh',
      };
    },
    reshycnHandleSizeChange(val) {
      this.params.size = val;
      this.params.current = 1;
      this.getReshycnData();
    },
    //切换页码
    gzHandleCurrentChange(val) {
      this.params.current = val;
      this.getReshycnData();
    },
    getReshycnData() {
      this.loading = true;
      let params = {
        ...this.params,
        hycncdnm: this.curInputValue + '',
      };
      this.request.get('/rm-breshycn/queryResHycnPage', {params: params}).then(res => {
        if (res.ok) {
          if (res.data != null) {
            this.reshycnTableData = res.data['records'];
            this.params.total = res.data['total'];
            this.params.size = res.data['size'];
            // this.reshycnTableData = res.data;
            // console.log(res, '===getReshycnDataRes===');
          } else {
            this.$message.info("获取建筑物信息数据为空");
          }
        } else {
          this.$message.error(res.error.message);
        }
        this.loading = false;
      });
    },
  },
  watch: {
    "$store.state.head.skCd"() {
      this.resetReshycnDataDeal();
    }
  }

}
</script>

<style scoped>
.commonForm {
  padding-top: 4vh;
  padding-left: 6vh;
}

.commonDiv {
  position: relative;
  background-color: #FFFFFF;
  height: calc(100vh - 200px);
}

/deep/ .el-pagination {
  white-space: nowrap;
  color: #303133;
  font-weight: 700;
  transform: translate(0, -50%);
  position: relative;
  top: 50%;
  right: 20px;
}

.commonPage2 {
  position: absolute;
  right: 1.5rem;
  height: 60px;
}


</style>
